export default "__VITE_ASSET__D9Y4xXXC__"